// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent__Z2blr","modal":"modal__+njVP","modalBody":"modalBody","download-files":"download-files__Owjyc","section-update":"section-update__zkMVl"};